module.exports = __webpack_public_path__ + "img/202206.80e519c6.png";